export function getSortFieldsOrder(fieldName?: string) {
  if (!fieldName || fieldName === 'familyName') {
    return ['familyName', 'givenName'];
  }
  return ['givenName', 'familyName'];
}
